export default __webpack_public_path__ + "static/media/player.ec4f5ed4.svg";